import z from "zod";

export const FormSchema = z.object({
  groupName: z
    .string()
    .min(1, { message: "Group name is required." })
    .max(100, { message: "Group name must be under 100 characters." })
    .regex(/^[\w\s&’'-]+$/, { message: "Invalid characters in group name." }),

  registrationCode: z
    .string()
    .min(1, { message: "Registration code is required." })
    .max(20, { message: "Max 20 characters allowed." })
    .regex(/^[A-Z0-9]+$/, {
      message: "Only uppercase letters and digits allowed.",
    }),
  address: z
    .string()
    .min(1, { message: "Address is required." })
    .max(255, { message: "Address must be under 255 characters." })
    .regex(/^[\w\s,.-]+$/, { message: "Invalid characters in address." }),
  vat: z.string().min(1, { message: "VAT is required." }).regex(/^\d+$/, {
    message: "VAT must contain digits only.",
  }),
  buisnessPhoneCode: z.string().min(1, { message: "Select a country code" }),
  buisnessPhoneNumber: z.string().refine(val => /^[0-9\s\-()+]+$/.test(val), {
    message: "Only digits and common separators allowed",
    // TODO: add validation
    // Validation applies per selected country (length/format); invalid shows inline error.
  }),
  agreement: z.boolean().refine(val => val === true, {
    message: "You must agree to the Terms & Conditions.",
  }),
});

export type RestaurantGroupType = z.infer<typeof FormSchema>;
